module.exports = __webpack_public_path__ + "img/2.969b91a1.png";